import { ThemeProvider, CssBaseline } from '@mui/material';
import { BrowserRouter } from 'react-router-dom';
import { useBlockNumberWheel } from '@bluplanet/shared';
import theme from './theme';
import AppRouter from './router/routes';
import { BuyerAuthProvider } from '@/store/BuyerAuthContext';
import { BuyerStoreProvider } from '@/store/buyerStore';
import { BuyerPrefsProvider } from '@/store/BuyerPrefsContext';

export default function App() {
  // 全站数字输入框屏蔽滚轮增减（聚焦时滚轮误改值）；未聚焦时不抢滚动
  useBlockNumberWheel();
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <BrowserRouter>
        {/* Provider 包裹在 Router 内部，确保守卫/登录页可用 useNavigate */}
        <BuyerAuthProvider>
          <BuyerStoreProvider>
            <BuyerPrefsProvider>
              <AppRouter />
            </BuyerPrefsProvider>
          </BuyerStoreProvider>
        </BuyerAuthProvider>
      </BrowserRouter>
    </ThemeProvider>
  );
}
